<template>
  <v-container v-if="teams[$route.params.team].account">
    <v-delete-modal
      name="delete-library-modal"
      :title="
        $t('library.modals.deleteLibrary.title', {
          name: $h.getNameFromLibraryByUid(currentDeleteLibraryUid, 'folders', library, currentFolder),
        })
      "
      :text="$t('library.modals.deleteLibrary.text')"
      :deleteHandler="
        () => {
          deleteModalHandler(currentDeleteLibraryUid, 'folders');
        }
      "
    >
    </v-delete-modal>
    <v-delete-modal
      name="delete-library-file-modal"
      :title="
        $t('library.modals.deleteLibraryFile.title', {
          name: $h.getNameFromLibraryByUid(currentDeleteLibraryUid, 'files', library, currentFolder),
        })
      "
      :text="$t('library.modals.deleteLibraryFile.text')"
      :deleteHandler="
        () => {
          deleteModalHandler(currentDeleteLibraryUid, 'files');
        }
      "
    >
    </v-delete-modal>
    <!--<v-delete-modal-->
    <!--  name="delete-filterPresets-modal"-->
    <!--  :title="-->
    <!--    currentDeleteFilterPreset-->
    <!--      ? $h.formatFilterPresetName(currentDeleteFilterPreset, teams[$route.params.team].account.locale)-->
    <!--      : ''-->
    <!--  "-->
    <!--  :text="$t('library.modals.deleteFilterPreset.text')"-->
    <!--  :deleteHandler="-->
    <!--    () => {-->
    <!--      deleteFilterPresetModalHandler('library', setLibraryFilters);-->
    <!--    }-->
    <!--  "-->
    <!--&gt;-->
    <!--</v-delete-modal>-->
    <modal
      name="create-folder"
      class="envivo-modal"
      @before-open="$h.toggleHtmlScroll"
      @closed="resetCreateFolderModal()"
      @before-close="$h.toggleHtmlScroll"
      transition="pop-out"
      height="auto"
      adaptive
      :maxWidth="600"
      width="90%"
      scrollable
    >
      <div class="modal-wrapper">
        <div class="modal-title" v-if="!editFolderUid">
          {{ $t("library.modals.createFolder") }}
        </div>
        <div class="modal-title" v-if="editFolderUid">
          {{ $t("library.modals.editFolder") }}
        </div>
        <div class="modal-content">
          <form @submit.prevent>
            <v-textfield
              :label="$t('library.labels.folderName')"
              v-model="folderName"
              v-validate="'required'"
              name="title"
            ></v-textfield>
          </form>
        </div>
        <div class="modal-buttons">
          <a class="v1 simple" @click="$modal.hide('create-folder')">{{ $t("actions.cancel") }}</a>
          <v-button primary @click.native="submitLibraryFolder()" v-if="!editFolderUid"
            >{{ $t("actions.create") }}
          </v-button>
          <v-button primary @click.native="submitLibraryFolder(false)" v-if="editFolderUid"
            >{{ $t("actions.save") }}
          </v-button>
        </div>
      </div>
    </modal>
    <modal
      name="edit-file"
      class="envivo-modal"
      @before-open="$h.toggleHtmlScroll"
      @before-close="$h.toggleHtmlScroll"
      transition="pop-out"
      height="auto"
      adaptive
      :maxWidth="600"
      width="90%"
      scrollable
    >
      <div class="modal-wrapper">
        <div class="modal-title">{{ $t("library.modals.editFile") }}</div>
        <div class="modal-content">
          <form @submit.prevent>
            <v-textfield
              :label="$t('library.labels.fileName')"
              v-model="fileName"
              v-validate="'required'"
              name="title"
            ></v-textfield>
          </form>
        </div>
        <div class="modal-buttons">
          <a class="v1 simple" @click="$modal.hide('edit-file')">{{ $t("actions.cancel") }}</a>
          <v-button primary @click.native="submitLibraryFile()">{{ $t("actions.save") }}</v-button>
        </div>
      </div>
    </modal>
    <modal
      name="move-file"
      class="envivo-modal"
      @before-open="$h.toggleHtmlScroll"
      @before-close="beforeMoveFileModalClose"
      transition="pop-out"
      height="auto"
      adaptive
      :maxWidth="600"
      width="90%"
      scrollable
    >
      <div class="modal-wrapper">
        <div class="modal-title" v-if="!moveFolderActive && moveCurrentFile">
          {{ $t("library.modals.moveFile", { title: moveCurrentFile.title }) }}
        </div>
        <div class="modal-title" v-if="moveFolderActive && moveCurrentFolder">
          {{ $t("library.modals.moveFolder", { title: moveCurrentFolder.title }) }}
        </div>
        <div class="modal-content">
          <ul>
            <li class="bg-v2-blue-light flex items-center p-2">
              <div
                class="flex items-center justify-center rounded hover:bg-v2-secondary-500 hover:text-white"
                style="width: 25px; height: 25px; cursor: pointer"
                @click="goToParentMoveFolder"
                v-if="moveModalCurrentFolder && moveModalCurrentFolder.title"
              >
                <v2-icon :data="require('@icon/Icon=arrow-left.svg')"></v2-icon>
              </div>
              <div style="width: 16px" v-if="moveModalCurrentFolder && !moveModalCurrentFolder.title"></div>
              <div class="ml-4" v-if="moveModalCurrentFolder">
                {{ moveModalCurrentFolder.title ? moveModalCurrentFolder.title : $t("library.folders.mediathek") }}
              </div>
            </li>
            <li v-if="moveModalCurrentFolderFolders">
              <div
                v-for="folder in moveModalCurrentFolderFolders"
                :key="folder.uid"
                :class="{
                  'bg-v2-secondary-200': moveTargetFolder && folder.uid === moveTargetFolder.uid,
                  disabled: moveFolderActive && folder.uid === currentFolder.uid,
                }"
                class="flex justify-between items-center p-2 hover:bg-v2-secondary-100 cursor-pointer"
                @click="selectMoveTarget(folder)"
              >
                <div class="flex items-center">
                  <v2-icon :data="require('@icon/Icon=folder.svg')"></v2-icon>
                  <div class="ml-4">{{ folder.title }}</div>
                </div>
                <div
                  v-if="!moveFolderActive || folder.uid !== currentFolder.uid"
                  @click.stop="goToMoveFolder(folder)"
                  style="width: 25px; height: 25px"
                  class="flex items-center justify-center rounded hover:bg-v2-secondary-500 hover:text-white"
                >
                  <v2-icon :data="require('@icon/Icon=chevron-right.svg')"></v2-icon>
                </div>
              </div>
            </li>
            <li class="flex mt-4">
              <v-button secondary small @click.native="toggleMoveCreateNewFolder()" v-if="!moveCreateNewFolderActive">
                {{ $t("library.actions.createLibraryFolder") }}
              </v-button>
              <v2-textfield v-model="moveCreateNewFolderTitle" v-if="moveCreateNewFolderActive"></v2-textfield>
              <v-button primary class="ml-4" v-if="moveCreateNewFolderActive" @click.native="moveCreateNewFolder()">
                {{ $t("actions.save") }}
              </v-button>
            </li>
          </ul>
        </div>
        <div class="modal-buttons">
          <a class="v1 simple" @click="$modal.hide('move-file')">{{ $t("actions.cancel") }}</a>
          <v-button primary @click.native="submitMove()" :active="isReadyToMove">
            {{ $t("actions.move") }}
          </v-button>
        </div>
      </div>
    </modal>
    <!--    <modal name="saveFilterPreset" class="envivo-modal"-->
    <!--           @before-open="$h.toggleHtmlScroll"-->
    <!--           @before-close="$h.toggleHtmlScroll" transition="pop-out" height="auto" adaptive-->
    <!--           :maxWidth="600" width="90%" scrollable>-->
    <!--      <div class="modal-wrapper">-->
    <!--        <div class="modal-title">{{ $t('titles.saveFilterPreset')}}</div>-->
    <!--        <div class="modal-content">-->
    <!--          <form @submit.prevent>-->
    <!--            <v-textfield :label="$t('labels.giveFilterPresetName')" v-model="filterPresetName"-->
    <!--                         v-validate="'required'" name="title"></v-textfield>-->
    <!--          </form>-->
    <!--        </div>-->
    <!--        <div class="modal-buttons">-->
    <!--          <a class="simple" @click="$modal.hide('saveFilterPreset')">{{ $t('actions.cancel') }}</a>-->
    <!--          <v-button primary @click.native="saveFilterPreset('library')">
    {{ $t('actions.createFilterPreset') }}</v-button>-->
    <!--          <v-button primary @click.native="saveFilterPreset('library', true)"-->
    <!--                    :active="teamsSettings[$route.params.team].listsSettings.library.currentFilterPreset-->
    <!--                    && !teamsSettings[$route.params.team].listsSettings.library.currentFilterPreset.is_global
    ? true : false">-->
    <!--            {{ $t('actions.editFilterPreset') }}</v-button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </modal>-->
    <v2-row>
      <v2-col col12 noSpace>
        <v2-header-bar :titles="[{ label: $t('library.title') }]">
          <template v-slot:tip>
            <v2-tip inside sm v-if="showTips" class="mb-2">{{ $t("tips.library.manage") }}</v2-tip>
          </template>
        </v2-header-bar>
      </v2-col>
    </v2-row>
    <!--<v-row class="mb-0">-->
    <!--  <v-col stretch>-->
    <!--    <div class="flex flex-wrap">-->
    <!--      <div v-for="preset in filterPresets" :key="preset.name">-->
    <!--        <v-button-->
    <!--          lavender-->
    <!--          small-->
    <!--          @click.native="selectFilterPreset(preset)"-->
    <!--          v-if="preset.is_global"-->
    <!--          class="combi-btn"-->
    <!--          :selected="-->
    <!--            teamsSettings[$route.params.team].listsSettings.library.currentFilterPreset &&-->
    <!--            preset.uid === teamsSettings[$route.params.team].listsSettings.library.currentFilterPreset.uid-->
    <!--          "-->
    <!--          >{{ $h.formatFilterPresetName(preset, teams[$route.params.team].account.locale) }}</v-button-->
    <!--        >-->
    <!--        <v-combi-button-->
    <!--          v-if="!preset.is_global"-->
    <!--          :selected="-->
    <!--            teamsSettings[$route.params.team].listsSettings.library.currentFilterPreset &&-->
    <!--            preset.uid === teamsSettings[$route.params.team].listsSettings.library.currentFilterPreset.uid-->
    <!--          "-->
    <!--          :first="{-->
    <!--            lavender: true,-->
    <!--            small: true,-->
    <!--            onClick: () => {-->
    <!--              selectFilterPreset(preset);-->
    <!--            },-->
    <!--          }"-->
    <!--          :second="{-->
    <!--            lavender: true,-->
    <!--            hoverDanger: true,-->
    <!--            small: true,-->
    <!--            icon: 'close',-->
    <!--            onClick: () => {-->
    <!--              showDeleteFilterPresetModal(preset);-->
    <!--            },-->
    <!--          }"-->
    <!--          >{{ $h.formatFilterPresetName(preset, teams[$route.params.team].account.locale) }}</v-combi-button-->
    <!--        >-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  </v-col>-->
    <!--</v-row>-->
    <!--<v-row-->
    <!--  v-if="teamsSettings[$route.params.team] &&
    teamsSettings[$route.params.team].listsSettings.library.filterActive"-->
    <!--&gt;-->
    <!--  <v-col stretch>-->
    <!--    <v-card custom class="p-6">-->
    <!--      <div slot="content" class="flex flex-row sm:flex-row w-full justify-between">-->
    <!--        <div>-->
    <!--          <div class="flex">-->
    <!--            <div class="text-grey-lavender mb-1">-->
    <!--              {{-->
    <!--                !teamsSettings[$route.params.team].listsSettings.clients.currentFilterPreset-->
    <!--                  ? $t("filters.results")-->
    <!--                  : $h.formatFilterPresetName(-->
    <!--                      teamsSettings[$route.params.team].listsSettings.clients.currentFilterPreset-->
    <!--                    )-->
    <!--              }}-->
    <!--            </div>-->
    <!--            <div-->
    <!--              class="text-danger ml-1"-->
    <!--              v-if="teamsSettings[$route.params.team].listsSettings.clients.currentFilterPresetHasChanged"-->
    <!--            >-->
    <!--              &#42;-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <h6>-->
    <!--            {{-->
    <!--              $tc(-->
    <!--                "filters.libraryResult",-->
    <!--                teamsSettings[$route.params.team].listsSettings.library.pagination.total,-->
    <!--                { result: teamsSettings[$route.params.team].listsSettings.library.pagination.total }-->
    <!--              )-->
    <!--            }}-->
    <!--          </h6>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <v-button class="mt-4 sm:mt-0" attention
    @click.native="resetFilters(setLibraryFilters, 'library')">-->
    <!--            {{ $t("filters.resetFilter") }}</v-button-->
    <!--          >-->
    <!--          <v-button primary @click.native="showSaveFilterPresetModal('library')">-->
    <!--            {{ $t("actions.saveFilterPreset") }}</v-button-->
    <!--          >-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </v-card>-->
    <!--  </v-col>-->
    <!--</v-row>-->
    <v-row class="mb-0 h-full">
      <v-col class="col-12 pb-0">
        <v2-uppy-upload
          id="library-uppy-upload"
          :locale="teams[$route.params.team].account.locale"
          v-if="currentFolder"
          :openModal="openModal"
          :addEvent="{
            event: 'dashboard:modal-closed',
            method: () => {
              setModal(false);
            },
          }"
          :trigger="null"
          :create-file="createFile"
          :uploadConfig="uploadConfig"
          :closeAfterFinish="true"
          @completed="setLibraryFilters"
        ></v2-uppy-upload>
        <v-media-library
          :folders="library.folders"
          :rootFolderName="$t('library.folders.mediathek')"
          :rootFolderIndex="-1"
          :breadcrumbs="currentFolderBreadcrumbs"
          :currentFolder="currentFolder"
          :totalFiles="teamsSettings[$route.params.team].listsSettings.libraryFiles.pagination.total"
          :createFolder="
            () => {
              $modal.show('create-folder');
            }
          "
          :editFolder="
            () => {
              editFolder(currentFolder.uid);
            }
          "
          :moveFolder="
            () => {
              moveFolder(currentFolder.uid);
            }
          "
          :deleteFolder="
            () => {
              showDeleteModal(currentFolder.uid, 'folders');
            }
          "
          :createFile="
            () => {
              setModal(true);
            }
          "
          :loading="customLoading"
          :readOnly="false"
          @go-to-folder="goToFolder"
          @go-to-previous-folder="goToPreviousFolder"
        >
          <v-row
            v-if="currentFolder && library && library.files && teamsSettings[$route.params.team]"
            slot="files"
            class="mb-0 flex-grow"
          >
            <v-col class="col-12 p-0">
              <div class="flex flex-col h-full">
                <v-list-header complex :style="'margin-right:' + scrollbarWidth + 'px'">
                  <v-list-header-cell emptyIcon></v-list-header-cell>
                  <v-list-header-cell
                    size="4"
                    :showAs="$t('library.labels.fileName')"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="sortMainColDropdown"
                  />
                  <v-list-header-cell
                    :showAs="$t(teamsSettings[$route.params.team].listsSettings.libraryFiles.showAs.firstCol.label)"
                    :size="teamsSettings[$route.params.team].listsSettings.libraryFiles.showAs.firstCol.size"
                    :showAsDropdownUid="$h.createUniqueUid()"
                    :showAsDropdown="showAsFirstColDropdown"
                  />
                  <v-list-header-cell
                    :mobile="$t('actions.sort')"
                    :mobileDropdownUid="$h.createUniqueUid()"
                    :mobileDropdown="mobileDropdown"
                  />
                  <!--<v-list-header-cell-->
                  <!--  filter-->
                  <!--  dropdownRight-->
                  <!--  multiselect-->
                  <!--  :filterActive="teamsSettings[$route.params.team].listsSettings.libraryFiles.filterActive"-->
                  <!--  :filterDropdownUid="$h.createUniqueUid()"-->
                  <!--  :filterDropdown="filterDropdown"-->
                  <!--/>-->
                  <v-list-header-cell emptyIcon />
                </v-list-header>
                <ul class="list relative flex-grow">
                  <div class="limited-height w-full h-full absolute overflow-y-scroll">
                    <library-list-item
                      v-for="file in library.files"
                      :key="'libraryfile_' + file.uid"
                      :file="file"
                      :moreDropdown="moreDropdown"
                      :moreDropdownWithDisabled="moreDropdownWithDisabled"
                      :timezone="teams[$route.params.team].account.timezone"
                      :statiBits="statiBits"
                      :listsSettings="teamsSettings[$route.params.team].listsSettings"
                      :getSelf="getLibraryFile"
                      :currentFolder="currentFolder"
                      :getPreview="getLibraryImagePreview"
                      :team="$route.params.team"
                      :hideCheckbox="true"
                    >
                    </library-list-item>
                    <v-list-item v-if="!library.files.length">
                      <v-list-cell :value="$t('library.placeholders.noFiles')"></v-list-cell>
                    </v-list-item>
                  </div>
                </ul>
                <v-list-pagination
                  :currentPage="teamsSettings[$route.params.team].listsSettings.libraryFiles.pagination.page"
                  :showPerPage="teamsSettings[$route.params.team].listsSettings.libraryFiles.pagination.perPage"
                  :totalPages="teamsSettings[$route.params.team].listsSettings.libraryFiles.pagination.lastPage"
                  :apiCall="
                    (page, perPage) => {
                      changeFilesPage(page, perPage);
                    }
                  "
                >
                </v-list-pagination>
              </div>
            </v-col>
          </v-row>
        </v-media-library>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import listSettings from "@/mixins/listSettings.js";
import library from "@/mixins/dropdowns/library.js";
import LibraryListItem from "@/views/partials/LibraryListItem.vue";
import filterPresets from "@/mixins/filterPresets.js";
import teamAbilities from "@/mixins/teamAbilities.js";

export default {
  name: "Library",
  components: {
    LibraryListItem,
  },
  mixins: [listSettings, library, filterPresets, teamAbilities],
  data() {
    return {
      openModal: false,
      folderName: "",
      fileName: "",
      editFolderUid: null,
      editFileUid: null,
      customLoading: false,
      currentDeleteLibraryUid: null,
      currentDeleteLibraryType: null,
      moveFolderActive: false,
      moveCurrentFile: null,
      moveCurrentFolder: null,
      moveModalCurrentFolder: null,
      moveModalCurrentParentFolder: null,
      moveModalCurrentFolderFolders: null,
      moveTargetFolder: null,
      moveCreateNewFolderActive: false,
      moveCreateNewFolderTitle: "",
      uploadConfig: {
        max_files: -1,
      },
      breadcrumbLibraryItems: [],
      customPlugins: [],
      // searchObject: {
      //   search: () => {},
      //   searchIcon: 'folder-client',
      //   searchText: 'placeholders.searchFile',
      //   searched: false,
      //   searchInitValue: ''
      // },
      scrollbarWidth: "15",
      moreDropdown: [
        {
          options: [
            {
              label: this.$t("actions.download"),
              method: (uid) => {
                this.downloadFile(uid);
              },
              doNotShowActiveState: true,
              disabled: false,
            },
            {
              label: this.$t("actions.move"),
              method: (uid) => {
                this.moveFile(uid);
              },
              doNotShowActiveState: true,
              disabled: false,
            },
            {
              label: this.$t("actions.edit"),
              method: (uid) => {
                this.editFile(uid);
              },
              doNotShowActiveState: true,
              disabled: false,
            },
            {
              label: this.$t("actions.delete"),
              method: (uid) => {
                this.showDeleteModal(uid, "files");
              },
              color: "text-danger",
              doNotShowActiveState: true,
            },
          ],
        },
      ],
      moreDropdownWithDisabled: [
        {
          options: [
            {
              label: this.$t("actions.download"),
              method: () => {},
              doNotShowActiveState: true,
              disabled: true,
            },
            {
              label: this.$t("actions.edit"),
              method: () => {},
              doNotShowActiveState: true,
              disabled: true,
            },
            {
              label: this.$t("actions.delete"),
              method: (uid) => {
                this.showDeleteModal(uid, "files");
              },
              color: "text-danger",
              doNotShowActiveState: true,
            },
          ],
        },
      ],
    };
  },
  created() {
    this.customLoading = true;
    this.uploadConfig.max_size = this.teamUploadConfig().max_size;
    this.createdFunction();
    this.getScrollbarWidth();
  },
  updated() {
    this.mountedFunction();
  },
  beforeDestroy() {
    // this.$parent.$data.search = () => {}
    // this.$parent.$data.searchInitValue = ''
    // this.$parent.$data.withSearch = false
    // this.$parent.$data.searchIcon = ''
    // this.$parent.$data.searchText = ''
  },
  methods: {
    ...mapActions([
      "getLibraryFoldersList",
      "getLibraryFilesList",
      "getLibraryFolder",
      "getLibraryFile",
      "deleteLibraryFolder",
      "setListsSettings",
      "deleteLibraryFile",
      "toggleDropdown",
      "getTeamTags",
      "getFilterPresets",
      "getFilterPreset",
      "createFilterPreset",
      "editFilterPreset",
      "deleteFilterPreset",
      "setCurrentFilterPreset",
      "setCurrentFilterPresetHasChanged",
      "createLibraryFolder",
      "editLibraryFolder",
      "editLibraryFile",
      "getLibraryImagePreview",
      "downloadLibraryFile",
      "createLibraryFolderFile",
    ]),
    createFile(data) {
      var vm = this;
      return new Promise((resolve, reject) => {
        if (!vm.currentFolder) {
          reject(new Error("no folder"));
        }
        vm.createLibraryFolderFile({ data: data.data, customLoading: true })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createdFunction() {
      if (this.$route.params.uid) {
        let vm = this;
        this.getLibraryFolder({
          folder: this.$route.params.uid,
          setCurrent: true,
          customLoading: true,
        }).then(() => {
          vm.loadPageData();
        });
      } else {
        this.$store.commit("LIBRARY_SET_CURRENT_FOLDER", null);
        this.$store.commit("LIBRARY_SET_CURRENT_FOLDER_META", null);
        this.loadPageData();
      }
      // this.teamsSettings[this.$route.params.team].listsSettings && this.teamsSettings[this.$route.params.team].listsSettings.library.search !== '' ? this.searchObject.searched = true : this.searchObject.searched = false
      // this.$store.commit('GLOBAL_INIT_SEARCHOBJECT', this.searchObject)
    },
    mountedFunction() {
      // this.$parent.$data.search = () => { return this.search('library', this.getLibrary) }
      // if (this.teamsSettings[this.$route.params.team].listsSettings) {
      //   this.$parent.$data.searchInitValue = this.teamsSettings[this.$route.params.team].listsSettings.library.search
      //   this.$eventbus.$emit('setSearchInitValue', this.teamsSettings[this.$route.params.team].listsSettings.library.search)
      // }
      // this.$parent.$data.withSearch = true
      // this.$parent.$data.searchIcon = 'folder-client'
      // this.$parent.$data.searchText = 'placeholders.searchLibrary'
    },
    loadPageData() {
      const vm = this;
      this.customLoading = true;
      // this.loadFilterPresets('library')
      // vm.$store.commit('GLOBAL_CUSTOM_LOADING_STARTED')
      let folderP = {
        page: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFolders.pagination.page,
        per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFolders.pagination.perPage,
        order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFolders.order.col,
        order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFolders.order.dir,
      };
      let filesP = {
        page: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFiles.pagination.page,
        per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFiles.pagination.perPage,
        order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFiles.order.col,
        order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFiles.order.dir,
      };
      let folderParams = vm.setFilterRequestObjectFromStore("libraryFolders", folderP);
      let finalFolderParams = {
        folder: vm.currentFolder ? vm.currentFolder.uid : "",
        setListsSettings: true,
        customLoading: true,
        params: folderParams,
      };
      let finalFilesParams = null;
      if (vm.currentFolder) {
        let filesParams = vm.setFilterRequestObjectFromStore("libraryFiles", filesP);
        finalFilesParams = {
          folder: vm.currentFolder.uid,
          setListsSettings: true,
          customLoading: true,
          params: filesParams,
        };
      }
      if (finalFolderParams && finalFilesParams) {
        var p1 = vm.getLibraryFoldersList(finalFolderParams);
        var p2 = vm.getLibraryFilesList(finalFilesParams);
        Promise.all([p1, p2])
          .then(() => {
            vm.initSort("libraryFiles");
            vm.initShowAs("libraryFiles");
            // vm.initFilters('libraryFiles')
            vm.customLoading = false;
          })
          .catch(() => {
            vm.customLoading = false;
          });
      } else if (finalFilesParams) {
        vm.getLibraryFilesList(finalFilesParams)
          .then(() => {
            vm.initSort("libraryFiles");
            vm.initShowAs("libraryFiles");
            // vm.initFilters('libraryFiles')
            vm.customLoading = false;
          })
          .catch(() => {
            vm.customLoading = false;
          });
      } else {
        vm.getLibraryFoldersList(finalFolderParams)
          .then(() => {
            vm.customLoading = false;
          })
          .catch(() => {
            vm.customLoading = false;
          });
      }
    },
    // callLists (libraryFolderParams, libraryFilesParams) {
    //   console.log('CALLSLIST', libraryFolderParams, libraryFilesParams)
    //   if (libraryFolderParams && libraryFilesParams) {
    //     var p1 = this.getLibraryFoldersList(libraryFolderParams)
    //     var p2 = this.getLibraryFilesList(libraryFilesParams)
    //     Promise.all(p1, p2).then(() => {
    //       this.customLoading = false
    //     }).catch(() => {
    //       this.customLoading = false
    //     })
    //   } else if (libraryFilesParams) {
    //     this.getLibraryFilesList(libraryFilesParams).then(() => {
    //       this.customLoading = false
    //     }).catch(() => {
    //       this.customLoading = false
    //     })
    //   } else {
    //     this.getLibraryFoldersList(libraryFolderParams).then(() => {
    //       this.customLoading = false
    //     }).catch(() => {
    //       this.customLoading = false
    //     })
    //   }
    // },
    resetCreateFolderModal() {
      this.editFolderUid = null;
      this.folderName = "";
    },
    sortLibraryFiles(col, dir) {
      let params = {
        // search: this.$parent.$data.searchQuery,
        page: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.pagination.page,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.pagination.perPage,
        order_col: col,
        order_dir: dir,
      };
      this.getLibraryFiles(params);
    },
    // changeFoldersPage (page, perPage) {
    //   let params = {
    //     search: this.$parent.$data.searchQuery,
    //     page,
    //     per_page: perPage,
    //     order_col: this.teamsSettings[this.$route.params.team].listsSettings.library.folders.order.col,
    //     order_dir: this.teamsSettings[this.$route.params.team].listsSettings.library.folders.order.dir
    //   }
    //   this.getLibraryFolders(params)
    // },
    changeFilesPage(page, perPage) {
      let params = {
        // search: this.$parent.$data.searchQuery,
        page,
        per_page: perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.dir,
      };
      this.getLibraryFiles(params);
    },
    setLibraryFilters() {
      this.getLibraryFolders({
        // search: this.$parent.$data.searchQuery,
        page: 1,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.libraryFolders.pagination.perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.libraryFolders.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.libraryFolders.order.dir,
      });
      if (this.currentFolder) {
        this.getLibraryFiles({
          // search: this.$parent.$data.searchQuery,
          page: 1,
          per_page: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.pagination.perPage,
          order_col: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.col,
          order_dir: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.dir,
        });
      }
      this.$eventbus.$emit("closeAllDropdowns");
    },
    getLibraryFolders(params) {
      this.filterDropdown[0].options.forEach((option) => {
        if (option.active && option.switch && option.switch.name && !option.select) {
          params[option.switch.name] = option.switch.model;
        }
        if (option.active && option.select && !option.select.custom) {
          params[option.select.name] = this.transformModelToRequestArray(option.select.model);
        }
      });
      this.getLibraryFoldersList({
        folder: this.currentFolder ? this.currentFolder.uid : "",
        setListsSettings: true,
        customLoading: true,
        params,
      }).then(() => {
        // this.checkCurrentFilterPresetHasChanged('libraryFolders')
        // this.initSort('libraryFolders')
      });
    },
    getLibraryFiles(params) {
      if (this.currentFolder) {
        this.filterDropdown[0].options.forEach((option) => {
          if (option.active && option.switch && option.switch.name && !option.select) {
            params[option.switch.name] = option.switch.model;
          }
          if (option.active && option.select && !option.select.custom) {
            params[option.select.name] = this.transformModelToRequestArray(option.select.model);
          }
        });
        this.getLibraryFilesList({
          setListsSettings: true,
          customLoading: true,
          folder: this.currentFolder.uid,
          params,
        }).then(() => {
          // this.checkCurrentFilterPresetHasChanged('libraryFiles')
          // this.initSort('libraryFiles')
        });
      }
    },
    showDeleteModal(uid, type) {
      this.currentDeleteLibraryType = type;
      this.currentDeleteLibraryUid = uid;
      if (type === "files") {
        this.$modal.show("delete-library-file-modal");
      } else if (type === "folders") {
        this.$modal.show("delete-library-modal");
      }
    },
    deleteModalHandler(uid, type) {
      this.customLoading = true;
      if (type === "files") {
        this.currentDeleteLibraryType = null;
        this.currentDeleteLibraryUid = null;
        this.$modal.hide("delete-library-file-modal");
        this.deleteLibraryFile({ file: uid, customLoading: true })
          .then(() => {
            this.getLibraryFilesList({
              folder: this.currentFolder.uid,
              setListsSettings: true,
              customLoading: true,
              params: {
                // search: this.$parent.$data.searchQuery,
                page: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.page,
                per_page: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.perPage,
                order_col: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.col,
                order_dir: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.dir,
              },
            }).then(() => {
              this.customLoading = false;
              this.$snotify.success(this.$t("library.toasts.deleteFile.success"), this.$t("toasts.success"), {
                icon: this.$successIcon,
              });
            });
          })
          .catch((err) => {
            this.customLoading = false;
            if (err.response && !err.response.data.error.custom) {
              this.$snotify.error(this.$t("library.toasts.deleteFile.error"), this.$t("toasts.error"), {
                timeout: 0,
                icon: this.$errorIcon,
              });
            }
          });
      } else if (type === "folders") {
        this.$modal.hide("delete-library-modal");
        this.deleteLibraryFolder({ customLoading: true })
          .then(() => {
            let goToFolderUid = "";
            if (this.currentFolderBreadcrumbs.length > 1) {
              goToFolderUid = this.currentFolderBreadcrumbs[this.currentFolderBreadcrumbs.length - 2].uid;
            }
            if (goToFolderUid !== "") {
              this.$router.push({
                name: "LibraryFolder",
                params: { uid: goToFolderUid },
              });
            } else {
              this.$router.push({ name: "Library" });
            }
            this.currentDeleteLibraryType = null;
            this.currentDeleteLibraryUid = null;
            this.$snotify.success(this.$t("library.toasts.deleteFolder.success"), this.$t("toasts.success"), {
              icon: this.$successIcon,
            });
          })
          .catch((err) => {
            this.customLoading = false;
            if (err.response && !err.response.data.error.custom) {
              this.$snotify.error(this.$t("library.toasts.deleteFolder.error"), this.$t("toasts.error"), {
                timeout: 0,
                icon: this.$errorIcon,
              });
            }
            this.currentDeleteLibraryType = null;
            this.currentDeleteLibraryUid = null;
            this.$modal.hide("delete-library-modal");
          });
      }
    },
    // selectFilterPreset (preset) {
    //   let vm = this
    //   let paramsP1 = {
    //     search: this.$parent.$data.searchQuery,
    //     page: 1,
    //     per_page: this.teamsSettings[this.$route.params.team].listsSettings.library.folders.pagination.perPage,
    //     order_col: this.teamsSettings[this.$route.params.team].listsSettings.library.folders.order.col,
    //     order_dir: this.teamsSettings[this.$route.params.team].listsSettings.library.folders.order.dir
    //   }
    //   Object.assign(paramsP1, preset.value)
    //   let paramsFolder = {
    //     setListsSettings: true,
    //     paramsP1
    //   }
    //   let paramsFiles = null
    //   if (this.currentFolder) {
    //     let paramsP2 = {
    //       search: this.$parent.$data.searchQuery,
    //       page: 1,
    //       per_page: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.pagination.perPage,
    //       order_col: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.col,
    //       order_dir: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.dir
    //     }
    //     Object.assign(paramsP2, preset.value)
    //     paramsFiles = {
    //       setListsSettings: true,
    //       paramsP2
    //     }
    //   }
    //   // @TODO: Update list key etc
    //   this.callLists(paramsFolder, paramsFiles).then(() => {
    //     vm.setCurrentFilterPresetHasChanged({ list: 'library', state: false })
    //     vm.setCurrentFilterPreset({ list: 'library', filterPreset: preset })
    //     this.$modal.hide('showFilterPresets')
    //     vm.initSort('library')
    //     vm.initShowAs('library')
    //     vm.initFilters('library')
    //   })
    // },
    goToFolder(uid) {
      this.customLoading = true;
      this.$store.commit("LIBRARY_RESET_LIBRARY_FILE_LIST");
      this.$router.push({ name: "LibraryFolder", params: { uid: uid } });
    },
    goToPreviousFolder() {
      const vm = this;
      vm.customLoading = true;
      vm.$store.commit("LIBRARY_RESET_LIBRARY_FILE_LIST");
      let previousFolder;
      if (vm.currentFolderBreadcrumbs.length > 1) {
        previousFolder = vm.currentFolderBreadcrumbs[vm.currentFolderBreadcrumbs.length - 2].uid;
        this.$router.push({
          name: "LibraryFolder",
          params: { uid: previousFolder },
        });
      } else {
        this.$router.push({ name: "Library" });
      }
    },
    goToMoveFolder(folder) {
      this.moveTargetFolder = null;
      const vm = this;
      let params = {};
      let finalFolderParams = {
        folder: folder.uid,
        setListsSettings: false,
        preventSetStoreState: true,
        customLoading: true,
        params: params,
      };
      this.getLibraryFoldersList(finalFolderParams).then((res) => {
        vm.moveModalCurrentParentFolder =
          vm.moveModalCurrentFolder && vm.moveModalCurrentFolder.uid ? vm.moveModalCurrentFolder.uid : "";
        vm.moveModalCurrentFolder = folder;
        vm.moveModalCurrentFolderFolders = res;
      });
    },
    goToParentMoveFolder() {
      this.moveTargetFolder = null;
      const vm = this;
      const setParent = vm.moveModalCurrentParentFolder !== "";
      let params = {};
      let finalFolderParams = {
        folder: vm.moveModalCurrentParentFolder,
        setListsSettings: false,
        preventSetStoreState: true,
        customLoading: true,
        params: params,
      };
      vm.getLibraryFoldersList(finalFolderParams).then((res) => {
        vm.moveModalCurrentFolderFolders = res;
      });
      vm.getLibraryFolder({
        customLoading: true,
        folder: vm.moveModalCurrentParentFolder,
      }).then((res) => {
        if (res.data.meta.breadcrumbs.length > 1 && setParent) {
          vm.moveModalCurrentParentFolder = res.data.meta.breadcrumbs[res.data.meta.breadcrumbs.length - 2].uid;
        } else {
          vm.moveModalCurrentParentFolder = "";
        }
        vm.moveModalCurrentFolder = res.data.data;
      });
    },
    editFolder(uid) {
      let folderToEdit;
      if (uid === this.currentFolder.uid) {
        folderToEdit = this.currentFolder;
      } else {
        folderToEdit = this.library.folders.find((folder) => {
          return folder.uid === uid;
        });
      }
      if (folderToEdit) {
        this.editFolderUid = folderToEdit.uid;
        this.folderName = folderToEdit.title;
        this.$modal.show("create-folder");
      }
    },
    moveFolder() {
      this.moveFolderActive = true;
      this.moveCurrentFolder = this.currentFolder;
      this.moveModalCurrentFolder = this.currentFolder;
      if (this.currentFolderBreadcrumbs.length > 1) {
        this.moveModalCurrentParentFolder = this.currentFolderBreadcrumbs[this.currentFolderBreadcrumbs.length - 2].uid;
      } else {
        this.moveModalCurrentParentFolder = "";
      }
      this.moveModalCurrentFolderFolders = this.library.folders;
      this.goToParentMoveFolder();
      this.$modal.show("move-file");
    },
    selectMoveTarget(folder) {
      if (folder.uid !== this.currentFolder.uid) {
        this.moveTargetFolder = folder;
      }
    },
    moveFile(uid) {
      const file = this.library.files.find((file) => {
        return file.uid === uid;
      });
      this.moveCurrentFile = file;
      this.moveModalCurrentFolder = this.currentFolder;
      if (this.currentFolderBreadcrumbs.length > 1) {
        this.moveModalCurrentParentFolder = this.currentFolderBreadcrumbs[this.currentFolderBreadcrumbs.length - 2].uid;
      } else {
        this.moveModalCurrentParentFolder = "";
      }
      this.moveModalCurrentFolderFolders = this.library.folders;
      this.$modal.show("move-file");
    },
    editFile(uid) {
      const fileToEdit = this.library.files.find((file) => {
        return file.uid === uid;
      });
      this.editFileUid = fileToEdit.uid;
      this.fileName = fileToEdit.title;
      this.$modal.show("edit-file");
    },
    submitLibraryFolder(create = true) {
      const vm = this;
      const data = {
        title: vm.folderName,
      };
      vm.$validator.validateAll().then((result) => {
        if (result) {
          if (create) {
            if (vm.currentFolder && vm.editFolderUid) {
              data.folder = vm.editFolderUid;
            } else if (vm.currentFolder && !vm.editFolderUid) {
              data.folder = vm.currentFolder.uid;
            }
            vm.createLibraryFolder({ data, customLoading: true })
              .then(() => {
                this.loadPageData();
                this.folderName = "";
                this.$modal.hide("create-folder");
                this.$snotify.success(this.$t("library.toasts.createFolder.success"), this.$t("toasts.success"), {
                  icon: this.$successIcon,
                });
              })
              .catch(() => {
                vm.$snotify.error(vm.$t("library.toasts.createFolder.error"), vm.$t("toasts.error"), {
                  timeout: 0,
                  icon: vm.$errorIcon,
                });
              });
          } else {
            vm.editLibraryFolder({ data, customLoading: true })
              .then(() => {
                if (this.editFolderUid === vm.currentFolder.uid) {
                  vm.getLibraryFolder({
                    customLoading: true,
                    folder: this.editFolderUid,
                    setCurrent: true,
                  }).then(() => {
                    vm.loadPageData();
                  });
                } else {
                  vm.loadPageData();
                }
                this.folderName = "";
                this.editFolderUid = null;
                this.$modal.hide("create-folder");
                this.$snotify.success(this.$t("library.toasts.editFolder.success"), this.$t("toasts.success"), {
                  icon: this.$successIcon,
                });
              })
              .catch(() => {
                vm.$snotify.error(vm.$t("library.toasts.editFolder.error"), vm.$t("toasts.error"), {
                  timeout: 0,
                  icon: vm.$errorIcon,
                });
              });
          }
        } else {
          if (create) {
            vm.$snotify.error(vm.$t("library.toasts.createFolder.validation"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          } else {
            vm.$snotify.error(vm.$t("library.toasts.editFolder.validation"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          }
        }
      });
    },
    toggleMoveCreateNewFolder() {
      this.moveCreateNewFolderActive = !this.moveCreateNewFolderActive;
    },
    moveCreateNewFolder() {
      const vm = this;
      const data = {
        title: vm.moveCreateNewFolderTitle,
      };
      vm.$validator.validateAll().then((result) => {
        if (result) {
          data.folder = vm.moveModalCurrentFolder.uid;
          vm.createLibraryFolder({ data, customLoading: true })
            .then(() => {
              // vm.loadPageData();
              vm.goToMoveFolder(vm.moveModalCurrentFolder);
              vm.moveCreateNewFolderTitle = "";
              vm.toggleMoveCreateNewFolder();
              vm.$snotify.success(vm.$t("library.toasts.createFolder.success"), vm.$t("toasts.success"), {
                icon: vm.$successIcon,
              });
            })
            .catch(() => {
              vm.$snotify.error(vm.$t("library.toasts.createFolder.error"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
            });
        } else {
          vm.$snotify.error(vm.$t("library.toasts.createFolder.validation"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
        }
      });
    },
    beforeMoveFileModalClose() {
      this.$h.toggleHtmlScroll();
      this.moveFolderActive = false;
      this.moveCurrentFile = null;
      this.moveCurrentFolder = null;
      this.moveModalCurrentFolder = null;
      this.moveModalCurrentParentFolder = null;
      this.moveModalCurrentFolderFolders = null;
      this.moveTargetFolder = null;
      this.moveCreateNewFolderTitle = "";
      this.moveCreateNewFolderActive = false;
    },
    submitMove() {
      if (this.moveFolderActive) {
        this.submitMoveLibraryFolder();
      } else {
        this.submitMoveLibraryFile();
      }
    },
    submitMoveLibraryFolder() {
      const vm = this;
      const data = {
        parent_folder: vm.moveTargetFolder.uid,
      };
      vm.editLibraryFolder({ data, customLoading: true })
        .then(() => {
          vm.getLibraryFolder({
            customLoading: true,
            folder: vm.moveCurrentFolder.uid,
            setCurrent: true,
          }).then(() => {
            vm.loadPageData();
          });
          vm.$modal.hide("move-file");
          vm.$snotify.success(this.$t("library.toasts.moveFolder.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch(() => {
          vm.$snotify.error(vm.$t("library.toasts.moveFolder.error"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
        });
    },
    submitMoveLibraryFile() {
      const vm = this;
      const data = {
        parent_folder: vm.moveTargetFolder.uid,
      };
      vm.editLibraryFile({
        params: { folder: vm.currentFolder.uid, file: vm.moveCurrentFile.uid },
        data: data,
        customLoading: true,
      })
        .then(() => {
          vm.getLibraryFolder({
            customLoading: true,
            folder: vm.currentFolder.uid,
            setCurrent: true,
          }).then(() => {
            vm.loadPageData();
          });
          vm.$modal.hide("move-file");
          vm.$snotify.success(this.$t("library.toasts.moveFile.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch(() => {
          vm.$snotify.error(vm.$t("library.toasts.moveFile.error"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
        });
    },
    submitLibraryFile() {
      const vm = this;
      const data = {
        title: vm.fileName,
      };
      vm.$validator.validateAll().then((result) => {
        if (result) {
          vm.editLibraryFile({
            params: { folder: vm.currentFolder.uid, file: vm.editFileUid },
            data: data,
            customLoading: true,
          })
            .then(() => {
              vm.getLibraryFolder({
                customLoading: true,
                folder: vm.currentFolder.uid,
                setCurrent: true,
              }).then(() => {
                vm.loadPageData();
              });
              this.$modal.hide("edit-file");
              this.$snotify.success(this.$t("library.toasts.editFile.success"), this.$t("toasts.success"), {
                icon: this.$successIcon,
              });
            })
            .catch(() => {
              vm.$snotify.error(vm.$t("library.toasts.editFile.error"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
            });
        } else {
          vm.$snotify.error(vm.$t("library.toasts.editFile.validation"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
        }
      });
    },
    downloadFile(uid) {
      this.downloadLibraryFile({
        file: uid,
        folder: this.currentFolder.uid,
        redirect: false,
      }).then((res) => {
        window.location = res.data.data.redirect;
      });
    },
    getScrollbarWidth() {
      let scrollDiv = document.createElement("div");
      scrollDiv.className = "scrollbar-measure";
      document.body.appendChild(scrollDiv);
      this.scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    },
    setModal(val) {
      this.openModal = val;
      if (!val) {
        this.$eventbus.$emit("resetUppy");
      }
    },
  },
  computed: {
    isReadyToMove() {
      return this.moveTargetFolder && this.moveTargetFolder.uid ? true : false;
    },
    ...mapGetters({
      teams: "auth_get_teams",
      teamsSettings: "global_get_teams_settings",
      library: "library_get_library_list",
      currentFolder: "library_get_current_folder",
      currentFolderBreadcrumbs: "library_get_current_folder_breadcrumbs",
      filterPresets: "filterpresets_get_filterpresets",
      currentLibraryFilePreviews: "library_get_library_file_previews",
      statiBits: "global_get_fileStatiBits",
      showTips: "global_get_show_tips",
    }),
  },
};
</script>
